// Search
export const IDI_IMPORT_START_LOADING = "IDI_IMPORT_START_LOADING";
export const IDI_IMPORT_END_LOADING = "IDI_IMPORT_END_LOADING";
export const IDI_IMPORT_LOADED = "IDI_IMPORT_LOADED";
